export default __webpack_public_path__ + "static/media/picto-user-grey.0cb6915c.svg";